import UserTagLogsPage from './UserTagLogsPage';

export default UserTagLogsPage;
